<!--
 * @Description:
 * @Version: 2.0
 * @Autor: dudedu
 * @Date: 2022-10-28 10:01:39
 * @LastEditors: dudedu
 * @LastEditTime: 2023-01-17 14:45:35
-->
<template>
  <div class="login-div__box login base-color__white base-flex__column-between">
    <!-- 顶部 -->
    <el-row style="z-index: 999">
      <!-- 左上角LOGO -->
      <el-col :span="20">
        <div style="text-align: left">
          <img class="login-img__header-logo" src="./image/q-lab-no-color.svg" />
        </div>
      </el-col>

      <!-- 右上角帮助 -->
      <el-col :span="4">
        <div class="base-flex">
          <div class="base-cursor__pointer">
            <el-dropdown v-if="false" @command="settingsLanguage">
              <span class="el-dropdown-link base-color__white">
                {{ $t('login.language') }}
                <i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="zh">中文</el-dropdown-item>
                <el-dropdown-item command="en">English</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
          <div class="base-cursor__pointer base-margin__left-20" @click="toCourse">
            {{ $t('login.helpCenter') }}
          </div>
        </div>
      </el-col>
    </el-row>

    <!-- 登录主体部分 -->
    <div class="base-flex__column-center login-div__margin-left">
      <!-- 名称 -->
      <div class="login-div__title1-box">
        <p class="login-p__title1">TENCENT</p>
      </div>
      <div class="login-div__title2-box">
        <h1 class="login-p__title2 base-color__white">{{ projectTitle ? 'OPEN CAE' : 'OPEN EDA' }}</h1>
        <h2 class="login-p__title2 base-color__white">{{ $t('login.serviceTitle') }}</h2>
        <h3 v-if="hunyuan" class="memo">
          {{ hunyuan }}
          <div class="memo-author">{{ $t('login.hunyuanAuthor') }}</div>
        </h3>
      </div>

      <!-- 登录按钮 -->
      <div class="base-margin__top-56">
        <img
          v-if="!projectTitle"
          class="login-img__qq-btn base-cursor__pointer"
          src="./image/QQ-login-normal.png"
          @click="onLogin"
        />
        <div class="base-margin__top-24 base-position__relative" @click="onLoginTXY">
          <img class="login-img__qq-btn base-cursor__pointer" src="./image/login.png" />
          <img class="base-position__absolute loginSvgCla" src="./image/login.svg" />
          <img class="base-position__absolute loginLogoSvgCla" src="./image/loginlogo.svg" />
        </div>
        <!--        <img class="login-img__wx-btn base-margin__top-20 base-cursor__pointer"-->
        <!--             src="./image/wx-login-normal.png"-->
        <!--             @click="onLoginTXY">-->
      </div>
      <div
        class="base-margin__top-40 base-flex__cross-center"
        style="margin-top: 40px; position: absolute; bottom: 15px"
      >
        <p class="login-p__contact-text">{{ $t('login.contactUs') }} {{ officialEmail }}</p>
        <img class="base-margin__left-16 width_140" src="./image/line.png" />
      </div>
    </div>

    <!-- 底部版权信息 -->
    <div class="login-div__footer-container login-div__margin-left">
      <p class="login-p__policy-text">Copyright © 1998-{{ new Date().getFullYear() }} Tencent. All Rights Resverved.</p>
      <p class="login-p__policy-text">{{ $t('login.copyright.tencent') }}</p>
      <p class="login-p__policy-text">
        openeda.cloud.tencent.com：
        <a class="login-a__footer-copy-right base-color__black" href="javascript:" target="_blank">
          {{ $t('login.copyright.license') }}
        </a>
      </p>
    </div>
    <div class="login-img__figure"></div>
  </div>
</template>

<script>
import { PATH_LOGIN, TENCENT_QQ_AUTH_URL, TEST_DEV_ENV, TEST_ENV, TEST_STAGING_ENV } from '@/common/constants';
import { getRequest } from '@/common/libs/request';
import { RELEASE_JSON_URL } from '@/common/utils/utils';
import Cookies from 'js-cookie';

export default {
  name: 'App',
  components: {
    // TefsButton,
  },
  data() {
    return {
      officialEmail: '',
      hunyuan: null,
      projectTitle: window.location.host.includes('cae'),
    };
  },
  created() {
    this.getEmail();
    this.getHunyuanInfo();
  },
  methods: {
    // 设置语言
    settingsLanguage(lang) {
      this.$i18n.locale = lang; // 设置当前语言
      Cookies.set('userLanguage', lang);
    },

    /**
     * 跳转快速入门文档
     */
    toCourse() {
      if (window.location.host.includes('eda')) {
        window.open(
          'https://eda-static-cdn-1300241787.file.myqcloud.com/build/Production/webdoc/openeda/1.%E8%85%BE%E8%AE%AF%E4%BA%91%E5%AD%90%E8%B4%A6%E5%8F%B7%E7%94%B3%E8%AF%B7.html',
        );
      } else {
        window.open(
          'https://eda-static-cdn-1300241787.file.myqcloud.com/build/Production/webdoc/opencae/1.%E8%85%BE%E8%AE%AF%E4%BA%91%E5%AD%90%E8%B4%A6%E5%8F%B7%E7%94%B3%E8%AF%B7.html',
        );
      }
    },

    /**
     * 获取混元助手通知
     */
    getHunyuanInfo() {
      // postRequest('/api/eda/common/eda/getCosApi', {
      //   key: 'notice.json',
      //   dir: 'public',
      //   contentType: 'text/html',
      // })
      getRequest(`${RELEASE_JSON_URL}?${new Date().getTime()}`).then((res) => {
        if (res.state === 'ok') {
          this.$router.replace('/maintenance').catch(() => {});
        } else {
          this.hunyuan = res?.hunyuan[Math.floor(Math.random() * res.hunyuan.length)];
        }
      });
    },

    // 获取邮箱
    getEmail() {
      getRequest('/api/common/getSetting?key=official_email').then((res) => {
        this.officialEmail = res;
      });
    },

    // 登录跳转
    onLogin() {
      const { host } = window.location;
      if (host === TEST_ENV) {
        // 如果是测试环境，需要加上测试环境标签，方便跳转
        window.location.href = `${TENCENT_QQ_AUTH_URL}&state=qqtest`;
        return;
      }
      if (host === TEST_DEV_ENV) {
        window.location.href = `${TENCENT_QQ_AUTH_URL}&state=qqdev`;
        return;
      }
      if (host === TEST_STAGING_ENV) {
        window.location.href = `${TENCENT_QQ_AUTH_URL}&state=qqstaging`;
      } else {
        window.location.href = `${TENCENT_QQ_AUTH_URL}&state=qq`;
      }
    },

    onLoginTXY() {
      window.location.href = `https://cloud.tencent.com/login?s_url=${encodeURIComponent(PATH_LOGIN)}`;
    },
  },
};
</script>

<style lang="scss" scoped>
/* 在你的全局样式文件中 */
@font-face {
  font-family: 'AlimamaDaoLiTi';
  src: url('./font/AlimamaDaoLiTi.woff2') format('woff2'),
    /* Super modern browsers */ url('./font/AlimamaDaoLiTi.woff') format('woff'),
    /* Pretty modern browsers */ url('./font/AlimamaDaoLiTi.ttf') format('truetype'); /* Safari, Android, iOS */
  font-weight: normal;
  font-style: normal;
}

.memo {
  font-size: 16px;
  bottom: 325px;
  color: #fff;
  opacity: 1;
  margin-top: 340px;
  text-align: left;
  line-height: 1.4;
  width: 440px;
  font-family: 'AlimamaDaoLiTi', sans-serif;

  &-author {
    text-align: right;
    padding-top: 10px;
  }
}

.login-div__box {
  width: 100vw;
  height: 100vh;
  min-width: 1460px;
  min-height: 750px;
  background: #2a83d4 url('./image/login-bg-color.png') center bottom;
  background-size: cover;
  padding: 36px 50px 48px 50px;
  position: relative;
  box-sizing: border-box;
}

.login-img__figure {
  position: absolute;
  right: 0;
  bottom: 0;
  min-width: 780px;
  width: calc(100vw - 678px);
  height: 100%;
  background: url('./image/login-bg-figure.png') no-repeat right bottom;
  background-size: contain;
}

.login-div__top {
  position: absolute;
  z-index: 999;
  left: 0;
}

.login-img__header-logo {
  width: 168px;
  height: 40px;
}

.login-p__title1 {
  font-size: 64px;
  -webkit-text-stroke: 1px rgba(110, 166, 239, 0.75);
  -webkit-text-fill-color: transparent;
}

.login-p__title2 {
  font-size: 64px;
  color: #ffffff;
  letter-spacing: 0;
  line-height: 72px;
  font-weight: 600;
  text-align: left;
}

.login-p__sub-title {
  font-size: 14px;
  color: white;
  letter-spacing: 0.58px;
  line-height: 18px;
  font-weight: 400;
  margin-top: -2em;
}

.login-div__footer-container {
  opacity: 0.6;
}

.login-a__footer-copy-right {
  color: #a6a5ba;
}

.login-a__footer-copy-right:hover {
  color: rgb(255, 255, 255);
}

.login-div__margin-left {
  margin-left: 100px;
}

.login-div__title1-box {
  width: 300px;
  height: 48px;
  opacity: 0.66;
  margin-bottom: -6px;
}

.login-div__title2-box {
  height: 144px;
  z-index: 999;
}

.login-div__sub-title-box {
  width: 344px;
  border-top: 28px solid #2571d8;
  border-right: 15px solid transparent;
}

.login-p__contact-text {
  font-size: 12px;
  color: #6d87ac;
  letter-spacing: 0.5px;
  line-height: 18px;
}

.login-p__policy-text {
  opacity: 0.4;
  font-size: 12px;
  color: #a6a5ba;
  letter-spacing: 0.5px;
  line-height: 18px;
}

.login-img__qq-btn {
  width: 440px;
  height: 76px;
  display: block;
}

/*.login-img__qq-btn:hover {*/
/*  content: url("./image/QQ-login-hover.png");*/
/*}*/

.login-img__qq-btn {
  width: 440px;
  height: 76px;
  display: block;
}

.loginSvgCla {
  width: 78px;
  left: 61px;
  top: 26.3px;
  opacity: 0.9;
}

.loginLogoSvgCla {
  width: 144px;
  left: 28px;
  top: 14px;
  opacity: 0.9;
}

.width_140 {
  width: 140px;
}
</style>
